var _rect, _path, _path2, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 157.5C130.98 157.5 156.5 131.98 156.5 100.5C156.5 69.0198 130.98 43.5 99.5 43.5C68.0198 43.5 42.5 69.0198 42.5 100.5C42.5 131.98 68.0198 157.5 99.5 157.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 171C138.66 171 170 140.332 170 102.5C170 64.6685 138.66 34 100 34C61.3401 34 30 64.6685 30 102.5C30 140.332 61.3401 171 100 171ZM100 160.707C67.1491 160.707 40.5181 134.647 40.5181 102.5C40.5181 70.353 67.1491 44.2927 100 44.2927C132.851 44.2927 159.482 70.353 159.482 102.5C159.482 134.647 132.851 160.707 100 160.707Z",
    fill: "#FFA14A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6433 69.5911C88.2972 65.5066 91.5191 62 95.6183 62H103.509C107.562 62 110.767 65.4304 110.493 69.4735L107.442 114.473C107.193 118.147 104.141 121 100.459 121H99.4319C95.795 121 92.764 118.215 92.4569 114.591L88.6433 69.5911Z",
    fill: "#FFA14A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 131,
    r: 7,
    fill: "#FFA14A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalWarning);
export default __webpack_public_path__ + "static/media/modal-warning.5fb33777f12d78830f446e45c65c12cc.svg";
export { ForwardRef as ReactComponent };